
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinchakan() {



const cardData = {
  keyword: 'Cab Service in Chakan MIDC',
  heading: 'eTravo: Reliable and Professional Corporate Cab Services in Chakan MIDC',
  headingDescription: 'eTravo offers specialized corporate cab services in Chakan MIDC, a major industrial hub near Pune known for its vast presence of automotive, engineering, and manufacturing units. Our services are designed to cater to companies of all sizes, providing consistent, on-time transportation for employees, executives, and business guests. With a fleet of modern, air-conditioned, GPS-enabled vehicles and professionally trained chauffeurs, eTravo ensures safety, comfort, and operational efficiency. Whether your company needs shift-based pickups, client visits, or executive travel, our flexible plans and real-time tracking help streamline mobility across Chakan MIDC.',

  top: 'Key Locations in Chakan MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Volkswagen India Pvt. Ltd.',
      description: 'A leading automobile manufacturing facility in Chakan. eTravo provides regular employee shuttle services and executive transfers for vendors, staff, and visiting global partners to and from this plant.'
    },
    {
      title: 'Mercedes-Benz India',
      description: 'Our premium cab services cater to corporate visitors, managers, and engineers commuting to the high-security Mercedes-Benz campus. We ensure professional, punctual, and luxury-grade transportation.'
    },
    {
      title: 'Mahindra Vehicle Manufacturers Ltd.',
      description: 'Chakan MIDC’s automotive hub relies heavily on transport efficiency. eTravo provides dedicated multi-shift staff transportation and tailored routes for large-scale workforce logistics.'
    },
    {
      title: 'Bajaj Auto Plant',
      description: 'One of India’s largest two-wheeler manufacturers. eTravo facilitates reliable daily commutes for employees and supports logistics staff with route-optimized, shift-aligned cab services.'
    },
    {
      title: 'Panasonic Energy India Co. Ltd.',
      description: 'From engineers to executives, we serve Panasonic’s personnel with punctual, clean, and safe cabs, offering hassle-free booking and round-the-clock support for shift-based operations.'
    },
    {
      title: 'Chakan MIDC Warehousing and Logistics Zones',
      description: 'Our services extend to warehousing parks, where logistics and supervisory staff require precise, real-time transport. eTravo helps streamline last-mile commutes with efficiency and reliability.'
    }
  ],

  services: [
    {
      name: 'Chakan MIDC Corporate Cab Rentals',
      description: 'Our corporate cab rentals offer businesses in Chakan MIDC flexible and scalable transportation solutions. Whether your company needs vehicles for daily use, executive travel, or events, we provide well-maintained cabs with trained chauffeurs. These rental options are ideal for short-term projects, long-term staffing needs, and operational mobility, allowing HR teams to optimize employee commute management. Each plan is customizable, ensuring route flexibility, dedicated driver availability, and simplified billing. Our rental contracts support both individual employee assignments and group transport planning.'
    },
    {
      name: 'Employee Transport Cab Chakan MIDC',
      description: 'eTravo specializes in structured employee transport services in Chakan MIDC, particularly for large-scale factories, automotive plants, and engineering units. We offer multiple shift-aligned pickup and drop options with route optimization to minimize commute times. All vehicles are GPS-enabled and monitored in real time for enhanced security and punctuality. Employees benefit from consistent schedules and comfortable rides, while employers enjoy reduced absenteeism and increased productivity. We work closely with HR departments to integrate transport schedules into your operations seamlessly.'
    },
    {
      name: 'Business Cab Services Chakan MIDC',
      description: 'For field staff, site engineers, or visiting stakeholders, our business cab services ensure efficient, professional travel across the industrial zone. We provide clean, sanitized sedans and SUVs that suit business protocols and project needs. These services are ideal for meetings, plant visits, or daily client engagements within and around Chakan MIDC. Our drivers are trained to handle corporate etiquette and understand industrial routes, ensuring every business ride is productive and on schedule. This service combines speed, professionalism, and local expertise.'
    },
    {
      name: 'Corporate Staff Cabs Chakan MIDC',
      description: 'Large-scale manufacturing firms and factories in Chakan MIDC require reliable transportation for hundreds of staff across multiple shifts. Our staff cabs are deployed with precision scheduling, real-time tracking, and 24/7 dispatch support. We offer single and multi-stop routes, AC comfort, and trained drivers who prioritize safety and punctuality. This service helps streamline your HR and admin operations while keeping employee satisfaction high. Whether your workforce resides nearby or in outer Pune, our network ensures they reach work on time, every time.'
    },
    {
      name: 'Reliable Corporate Cab Service Chakan MIDC',
      description: 'Known for timeliness, professionalism, and clean vehicles, eTravo’s corporate cab services in Chakan MIDC have become a preferred choice for many manufacturing giants. We offer complete transparency with live vehicle tracking, driver authentication, and prompt customer support. Whether your company is managing internal logistics, HR travel coordination, or VIP mobility, our service adapts to meet those needs. Our reliability lies in our tech-enabled operations, trained chauffeurs, and experience handling industrial zone logistics effectively.'
    },
    {
      name: 'AC Corporate Cabs Chakan MIDC',
      description: 'Every vehicle in our fleet is air-conditioned, regularly sanitized, and designed for comfort — especially crucial for long industrial commutes. Our AC cabs support employee health, reduce commute fatigue, and improve the overall travel experience. The clean, odor-free, and well-maintained interiors reflect your organization’s professionalism to both staff and visitors. Suitable for summer-heavy regions like Pune, our AC cabs ensure that even long-haul drives within Chakan MIDC are relaxing and efficient.'
    },
    {
      name: 'Staff Pickup and Drop Cab Chakan MIDC',
      description: 'Our pickup and drop cabs are structured around your operational calendar — with pre-planned routes, driver rosters, and multi-shift availability. We coordinate with your HR team to ensure timely cab availability for every worker, no matter the shift. Each ride is tracked and reported, offering transparency and accountability in transport operations. Whether your staff works night shifts, staggered hours, or weekends, eTravo ensures hassle-free commuting across Chakan MIDC and adjoining areas.'
    },
    {
      name: 'Affordable Business Cab Rentals Chakan MIDC',
      description: 'Designed for startups, SMEs, and cost-conscious enterprises, our affordable cab rentals provide efficient business transport without heavy costs. We offer budget-friendly packages with optional, pooled staff cabs, and monthly payment options. The goal is to make quality transportation accessible to businesses of all sizes in Chakan MIDC without sacrificing punctuality, safety, or service standards. These plans are ideal for growing companies that need dependable transport but want to stay lean.'
    },
    {
      name: 'Executive Cab Services Chakan MIDC',
      description: 'Our executive cab services cater to senior-level management and VIP guests, offering luxurious sedans, courteous chauffeurs, and on-time arrivals. These rides are designed with business dignity in mind — spotless vehicles, bottled water, chargers, and strict privacy. Perfect for board meetings, factory tours, or partner visits, this service adds polish to your company’s hospitality experience. Executives can travel across Chakan MIDC and Pune in comfort and peace, focusing on business while we handle the logistics.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Chakan MIDC',
      description: 'With fixed monthly contracts, we offer tailored transport plans for employees, contractors, and admin staff. These monthly rentals include daily commutes, shift-based trips, and inter-plant transfers. Our backend systems manage scheduling, billing, and reporting — making it easy for your company to manage mobility without day-to-day follow-ups. With eTravo’s monthly rentals, you gain a reliable transport backbone that adapts as your team and needs grow.'
    },
    {
      name: 'Industrial Area Employee Transport Chakan MIDC',
      description: 'For companies running 24/7 operations, employee transport becomes a backbone of productivity. We offer specialized solutions with priority on safety, route accuracy, and time adherence. From large manufacturing units to logistics firms, our transport network is built to handle peak and off-peak shift requirements. With centralized support and live dashboards, you always stay in control of your workforce mobility across Chakan MIDC.'
    },
    {
      name: 'Corporate Client Cabs Chakan MIDC',
      description: 'We help businesses create strong impressions by offering dedicated client pickup and drop services in and around Chakan MIDC. These services ensure that vendors, stakeholders, and international visitors are welcomed with class and comfort. Our chauffeurs are well-trained in corporate etiquette, and vehicles are always in showroom-ready condition. Bookings are flexible — from one-way drops to full-day assignments — and every detail is managed with precision.'
    },
    {
      name: 'Business Meeting Cabs Chakan MIDC',
      description: 'Need to get to an urgent meeting across town or host an external meeting on-site? Our business meeting cabs are dispatched with priority, providing route-optimized, punctual transport that helps your team stay focused on the task — not the travel. Whether scheduled in advance or needed last minute, eTravo ensures your people arrive prepared, on time, and stress-free.'
    },
    {
      name: 'Chakan Industrial Area Cab Hire',
      description: 'Our cab hire service is ideal for ad-hoc business travel, short-term needs, or event-based commutes. Whether you’re organizing a factory visit, training session, or staff transport for a few days, we provide flexible hire options that don’t require a long-term commitment. You get access to our full fleet, from sedans to vans, with driver assistance and real-time support.'
    },
    {
      name: 'Corporate Shuttle Cabs Chakan MIDC',
      description: 'Our corporate shuttle service connects multiple work locations, warehouses, and residential hubs to your Chakan MIDC facilities. Using minibuses or vehicles, we ensure timely, budget-conscious group transport. With live updates, route tracking, and passenger logs, this service is perfect for large factories, IT parks, or logistics companies that move teams in bulk daily.'
    }
  ],

  tableData: [
    ['Chakan MIDC Corporate Cab Rentals', 'Employee Transport Cab Chakan MIDC'],
    ['Business Cab Services Chakan MIDC', 'Corporate Staff Cabs Chakan MIDC'],
    ['Reliable Corporate Cab Service Chakan MIDC', 'AC Corporate Cabs Chakan MIDC'],
    ['Staff Pickup and Drop Cab Chakan MIDC', 'Affordable Business Cab Rentals Chakan MIDC'],
    ['Executive Cab Services Chakan MIDC', 'Monthly Corporate Cab Rentals Chakan MIDC'],
    ['Industrial Area Employee Transport Chakan MIDC', 'Corporate Client Cabs Chakan MIDC'],
    ['Business Meeting Cabs Chakan MIDC', 'Chakan Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Chakan MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services for Chakan MIDC",
    "WhyChoosedescription": "eTravo delivers tailored corporate cab solutions designed specifically for companies operating in Chakan Industrial Area MIDC. We understand the demanding schedules and logistical challenges in this rapidly growing industrial hub, providing dependable, punctual, and comfortable transportation that enhances employee productivity and reduces commute stress."
  },
  {
    "WhyChooseheading": "Diverse Fleet for Various Corporate Travel Needs",
    "WhyChoosedescription": "Our wide range of vehicles—including sedans, SUVs, and MUVs—caters to all corporate travel requirements, from daily employee commuting to executive visits and inter-office transfers. Every vehicle is maintained to ensure maximum comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Chakan MIDC Routes",
    "WhyChoosedescription": "Our professional drivers possess comprehensive knowledge of Chakan MIDC’s road networks and traffic conditions, ensuring timely pickups and efficient navigation that minimize delays and enhance ride reliability."
  },
  {
    "WhyChooseheading": "Flexible Booking and Scheduling Options",
    "WhyChoosedescription": "We offer a variety of booking options such as on-demand rides, scheduled pickups, and long-term contracts, allowing businesses to customize transportation services according to shifting workforce schedules and project demands."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our vehicles come equipped with advanced GPS tracking systems, enabling real-time monitoring of rides to ensure passenger safety, operational transparency, and quick incident response."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "Our billing process is clear and straightforward, offering detailed invoices that include trip logs and fare breakdowns, simplifying corporate expense management and reimbursement."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Protocols",
    "WhyChoosedescription": "Committed to passenger well-being, we implement rigorous hygiene standards such as regular sanitization, driver health screenings, and adherence to safety guidelines, ensuring a safe and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Dedicated Corporate Account Management",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who provides personalized support for bookings, resolves queries promptly, and tailors services to align with your company’s specific transportation needs."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas does your cab service cover in Chakan MIDC?",
      answer: "Our services cover Chakan Industrial Area MIDC and nearby industrial and commercial zones, ensuring comprehensive corporate transportation."
    },
    {
      question: "Can we schedule regular rides for employees in Chakan MIDC?",
      answer: "Yes, we offer scheduling options for recurring rides to provide consistent and reliable transportation."
    },
    {
      question: "Do you provide monthly billing for corporate clients?",
      answer: "Yes, we offer monthly billing cycles with detailed invoices to facilitate easy expense tracking."
    },
    {
      question: "Are your drivers trained in corporate etiquette?",
      answer: "Absolutely. Our drivers receive extensive training to maintain professionalism, safety, and courtesy."
    },
    {
      question: "How do you ensure passenger safety during rides?",
      answer: "We employ GPS tracking, conduct regular vehicle maintenance, and enforce strict hygiene and safety protocols."
    },
    {
      question: "Is dedicated support available for corporate clients in Chakan MIDC?",
      answer: "Yes, corporate clients have access to dedicated account managers and support teams for prompt assistance."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Manoj Kulkarni",
    designation: "Operations Manager, Chakan Motors",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate cab service in Chakan MIDC has significantly improved employee punctuality and overall commute experience.”"
  },
  {
    name: "Ms. Anjali Deshpande",
    designation: "HR Executive, Tech Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“The flexibility and dedicated support from eTravo make them our trusted partner for corporate transportation.”"
  }
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Chakan MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-chakan-midc.jpg",
  "description": "Efficient corporate cab service in Chakan MIDC for employee transport, business meetings, and industrial commutes. Affordable AC corporate cabs with reliable drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-chakan-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Chakan MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Chakan MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinchakan;